import { useHelpStore } from "@/stores/Help";


export default defineNuxtRouteMiddleware(() => {
	if (import.meta.client) {
		const { fetchResources } = useHelpStore();
		
		void fetchResources();
	}
});